'use strict';

let Marionette = require('backbone.marionette');
let template = require('./templates/message.hbs');
let polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({
  template: template,
  search: false,

  initialize: function() {
    this.listenTo(this.collection, 'reset', this.render);
  },

  serializeData: function () {
    let data = {};

    if (this.collection.length > 1) {
      data.message = polyglot.t('search.number_of_locations_found');
      data.locationCount = this.collection.length;
    } else if (this.collection.length === 1) {
      data.message = polyglot.t('search.one_location_found');
      data.locationCount = this.collection.length;
    } else {
      data.message = '';
    }

    return data;
  },

  onDomRefresh: function () {
    this.trigger('message-updated');
  },

  onSearch: function () {
    this.search = true;
    this.render();
  },
});
